import styled from 'styled-components';

const ItemMargin = styled.div`
  margin-left: 30px;
`;

export default ItemMargin;
